import { Controller } from "stimulus";

const ERROR_MESSAGE = "Sorry, something went wrong. No data was changed.";
const SAVED_DURATION = 2600;

export default class extends Controller {
  static targets = ["input", "save", "discard", "saved", "error", "activeCount"];

  connect() {
    this.savedValues = this.currentValues();
    this.refresh();
  }

  disconnect() {
    clearTimeout(this.savedTimer);
  }

  edit() {
    this.savedTarget.hidden = true;
    this.errorTarget.hidden = true;
    this.refresh();
  }

  discard() {
    this.inputTargets.forEach((input, index) => {
      input.value = this.savedValues[index];
    });
    this.edit();
  }

  async save(event) {
    event.preventDefault();
    if (!this.dirty() || this.saving) return;

    this.saving = true;
    this.saveTarget.disabled = true;

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        body: new FormData(this.element),
        credentials: "same-origin",
        headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.message || ERROR_MESSAGE);

      this.savedValues = this.currentValues();
      this.savedTarget.hidden = false;
      clearTimeout(this.savedTimer);
      this.savedTimer = setTimeout(() => {
        this.savedTarget.hidden = true;
      }, SAVED_DURATION);
    } catch (error) {
      this.errorTarget.textContent = error.message || ERROR_MESSAGE;
      this.errorTarget.hidden = false;
    } finally {
      this.saving = false;
      this.refresh();
    }
  }

  currentValues() {
    return this.inputTargets.map((input) => input.value);
  }

  dirty() {
    return this.inputTargets.some((input, index) => input.value !== this.savedValues[index]);
  }

  refresh() {
    const dirty = this.dirty();
    this.saveTarget.disabled = !dirty || Boolean(this.saving);
    this.discardTarget.hidden = !dirty;

    const active = this.savedValues.filter((value) => value.trim() !== "").length;
    this.activeCountTarget.textContent = `${active} of ${this.savedValues.length} active`;
  }
}
